import { Link } from "react-router-dom";

const quickLinks = [
  { label: "影视资讯", to: "/category/资讯" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "电影", to: "/category/电影" },
  { label: "关于唐心", to: "/about" },
];

const friendLinks = [
  { label: "唐心剧集库", to: "/category/电视剧" },
  { label: "唐心电影库", to: "/category/电影" },
  { label: "影视观察", to: "/category/资讯" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg font-bold text-foreground-950 font-heading">
                唐
              </span>
              <span className="text-lg font-bold tracking-wide font-heading text-background-50">
                唐心
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              唐心是一个专注影视资讯与作品推荐的内容平台。我们汇聚最新影视动态、热门电视剧与电影，提供丰富的作品介绍与剧情分析，帮助每一位影视爱好者快速发现值得一看的好内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-video-line", "ri-mail-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-200 hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </span>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">内容导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">友情链接</h4>
            <ul className="mt-4 space-y-2.5">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-300">
            © 2025 唐心影视 · 本站内容为演示示例，仅供学习与浏览使用
          </p>
          <p className="text-xs text-primary-300">
            健康观影 · 尊重版权 · 支持正版内容
          </p>
        </div>
      </div>
    </footer>
  );
}